const VISITOR_KEY = "fkbrg_vid";

export function getVisitorId() {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = (
      (typeof crypto !== "undefined" && crypto.randomUUID?.()) ||
      `v-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`
    ).slice(0, 64);
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

export async function trackVisit() {
  try {
    if (sessionStorage.getItem("fkbrg_tracked")) return;
    sessionStorage.setItem("fkbrg_tracked", "1");
    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
    await fetch(`${API}/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        visitor_id: getVisitorId(),
        path: window.location.pathname,
        referrer: document.referrer || null,
      }),
    });
  } catch {
    /* tracking must never break the page */
  }
}
